const routes = [
  {
    path: '/taskCenter', // 主页面
    name: 'taskCenter',
    redirect: '/taskCenter/list',
    component: () => import('@src/modules/taskCenter/Main'),
    meta: {
      requireAuth: true,
      routerAlive: true
    },
    children: [
      {
        path: 'index', // 任务中心
        name: 'taskCenterIndex',
        component: () => import('@src/modules/taskCenter/view/TaskCenter'),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: 'list', // 任务中心
        name: 'taskCenterList',
        component: () => import('@src/modules/taskCenter/view/List'),
        meta: {
          requireAuth: true,
          routerAlive: true
        },
      },
      {
        path: 'taskDetailComponent',
        name: 'taskDetailComponent',
        component: () => import('@src/modules/taskCenter/components/TaskDetailComponent'),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: 'taskAuditComponent', // 任务中心
        name: 'taskAuditComponent',
        component: () => import('@src/modules/taskCenter/components/TaskAuditComponent'),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: 'taskAssignComponent', // 任务中心
        name: 'taskAssignComponent',
        component: () => import('@src/modules/taskCenter/components/TaskAssignComponent'),
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
]

export default routes
